/**
 * @generated SignedSource<<0e0b9f5315d4a81aba052585bb4b8311>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebarCalendar_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Calendar_section"
    }
  ],
  "type": "PageSectionCalendar",
  "abstractKey": null
};

node.hash = "829c0d2173158d1a9e90201868abb70e";

module.exports = node;
